// extracted by css-extract-rspack-plugin
export default {"freeTrialSection":"src-shared-components-MainLayout-components-UserProfile-components-FreeTrialSection-FreeTrialSection-module__freeTrialSection-lgieVy","label":"src-shared-components-MainLayout-components-UserProfile-components-FreeTrialSection-FreeTrialSection-module__label-yYhF5H","leadingIcon":"src-shared-components-MainLayout-components-UserProfile-components-FreeTrialSection-FreeTrialSection-module__leadingIcon-MTsUf8"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"freeTrialSection\":\"src-shared-components-MainLayout-components-UserProfile-components-FreeTrialSection-FreeTrialSection-module__freeTrialSection-lgieVy\",\"label\":\"src-shared-components-MainLayout-components-UserProfile-components-FreeTrialSection-FreeTrialSection-module__label-yYhF5H\",\"leadingIcon\":\"src-shared-components-MainLayout-components-UserProfile-components-FreeTrialSection-FreeTrialSection-module__leadingIcon-MTsUf8\"}";
        // 1793874322458
        var cssReload = require("../../../../../../../../node_modules/.pnpm/@rspack+core@1.5.8_@swc+helpers@0.5.17/node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  